<template>
	<div class="pages">
		<div class="fx filter-wapper">
			<div class="fx fx-wrap fx-fill">
				<z-select :options="options" v-model="params.recommend"  class="w100" @handleChange="handleOffset(0)"></z-select>
			</div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="请输入分类名称..." @handleSearch="handleOffset(0)"></z-search></div>
			
		</div>
		<section class="classify-table">
			<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="(item, index) in columns">
					{{item.title}}
					<a 
						v-if="index==3" 
						:class="[params.orderBy=='order_number:ASC'?'up-sort':params.orderBy=='order_number:DESC'? 'down-sort':'']"
						class="arrow m-l-5"
						@click="handleListByOrder('order_number')">
					</a>
				</th>
				<tr slot="datasource" v-for="(item, index) in list.list || []">
					<td><z-img-hover :src="item.face"></z-img-hover></td>
					<td>{{item.name}}</td>
					<td>
						<!--<mt-switch v-model="item.recommend" @change="handleSetRecommend(item.id, item.recommend ? true : false)">{{item.recommend ? '是':'否' }}</mt-switch>-->
						<el-switch
						  v-model="item.recommend"
						  on-text="是"
						  off-text="否"
						  on-color="#2BB673"
						  off-color="#ff4949"
						  @change="handleSetRecommend(item.id, item.recommend)"
						  >
						</el-switch>
					</td>
					<td>
						<input class="input w60 text-center" type="number" :value="item.order_number" v-on:blur="handleSetOrderNumber(item.id, item.order_number)"/>
					</td>
					<td>
						<span>{{item.l_time | momentFmt}}</span>
					</td>
					<td class="operating">
						<router-link  class="operat-btn" tag="a" :to="{ name: 'classifyEdit',query:{id:item.id}}"><i class="icon-edit"></i><span>编辑</span></router-link>
						<!--<a class="operat-btn" @click="handleDelDo(item.id)"><i class="icon-del"></i><span>删除</span></a>-->
						<el-popover placement="top" width="200" :ref="'popover_'+index">
							<div class="z-popover">
								<div>确定要删除此条数据?</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleDelDo(item.id)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i class="icon-del"></i><span>删除</span></a>
						</el-popover>
					</td>
				</tr>
				<div slot="operate">
					<router-link class="z-btn z-btn-primary b-r-3" tag="a" :to="{ name: 'classifyEdit'}">新建分类</router-link>
				</div>
			</z-table>
		</section>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'Classify',
		components: {},
		data() {
			return {
				options: [{
					value: '',
					text: '是否推荐'
				}, {
					value: 1,
					text: '是'
				}, {
					value: 0,
					text: '否'
				}],
				columns: [{
					title: '图标',
				}, {
					title: '名称',
				}, {
					title: '首页推荐',
					orderBy: 'recommend',
					orderType: 'ASC'
				}, {
					title: '排序',
					orderBy: 'order_number',
					orderType: 'ASC'
				}, {
					title: '最后修改时间',
					orderBy: 'l_time',
					orderType: 'ASC'
				}, {
					title: '操作'
				}],
				params: {
					offset: 0,//分页偏移量
					count: 10, //每页多少条
					search: '',//查询字符串
					type: 'page',
					orderBy: "l_time:DESC",
					recommend: ''
				},
				value: 0
			}
		},
		computed: {
			...mapState({
				list: state => state.vmall.list
			}),
			
			//选中排序状态
			chooseClass(index) {
				if (this.params.orderBy == 'l_time:DESC') {
					return 'arrow m-l-5';
				}
				
				if (this.columns[index].orderType == 'ASC') {
					return 'arrow m-l-5 up-sort';
				} else {
					return 'arrow m-l-5 down-sort';
				}
			}
		},
		mounted() {
			this.handleGetGoodsTypeList();
		},
		/*
		 * 事件处理
		 */
		methods: {
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['popover_' + index]) != "undefined") this.$refs['popover_' + index][0].doClose();
			},
			//排序
			handleListByOrder(orderBy) {
				if (this.params.orderBy == 'l_time:DESC') {
					this.params.orderBy = orderBy + ':ASC';
				} else {
					this.params.orderBy = this.params.orderBy == orderBy + ':ASC' ? orderBy + ':DESC' : orderBy + ':ASC';
				}
				
				this.params.offset = 0;
				this.handleGetGoodsTypeList();
			},
			
			//设置商品分类是否为推荐
			handleSetRecommend(id, recommend) {
				if (!this.$re_Number(id)) return this.$warning('缺少必要的合法参数id');
				
				this.setGoodsTypeRecommend({id, recommend}).then((data)=>{
					this.$success('操作成功');
//					this.handleGetGoodsTypeList();
				},(msg)=>{
					this.$errorMsg(msg)
				})
			},
			
			//获取分类列表
			handleGetGoodsTypeList() {
				this.getGoodsTypeList(this.params)
			},
			
			//处理分页
			handleOffset(offset) {
				this.params.offset = offset;
				this.handleGetGoodsTypeList();
			},
			
			//新增或者编辑分类
			handleEdit(id = null) {
				this.$router.push({ name: 'editAdminVmall', query: { id: id}});
			},
			
			//删除管理员
			handleDelDo(id) {
				this.deleteGoodsType({id}).then((data)=>{
					this.$success('删除成功');
					this.handleGetGoodsTypeList();
				},(msg)=>{
					this.$errorMsg(msg)
				})
			},
			
			//设置分类排序
			handleSetOrderNumber(id, orderNumber) {
				let newNumber = event.target.value;
				if ( newNumber == orderNumber) return false;
				
				if (!this.$re_Number(newNumber)) return this.$warning('排序值不合法！');
				
				this.saveGoodsTypeOrderNumber({id,orderNumber: newNumber}).then((data) => {
					this.$success('设置成功');
				}, (error) => {
					this.$errorMsg(error);
				})
			},
			
			//点击排序
			getGoodsListByOrder(index) {
				if (this.columns[index].orderBy == 'undefined') return false;
				this.columns[index].orderType = this.columns[index].orderType == 'DESC' ? 'ASC' : 'DESC';
				this.params.orderBy = this.columns[index].orderBy + ':' + this.columns[index].orderType;
				this.handleGetGoodsTypeList();
			},
			...mapActions(['getGoodsTypeList', 'deleteGoodsType', 'setGoodsTypeRecommend', 'saveGoodsTypeOrderNumber']),
		},
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	
	.arrow{
		position: relative;
		&:before,&:after{
			content: "";
			position: absolute;
			width: 0;
			height: 0;
		}
		&:before{
			border-left: 3px solid transparent;
		    border-right: 3px solid transparent;
		    border-bottom: 6px solid $color-gray;
		    top: -0;
		    left: 0;
		}
		&:after{
			border-left: 3px solid transparent;
		    border-right: 3px solid transparent;
		    border-top: 6px solid $color-gray;
		    bottom: -0px;
		    left: 0;
		}
		&.up-sort{
			&:before{
				border-bottom-color: $color-main;
			}
		}
		&.down-sort{
			&:after{
				border-top-color: $color-main;
			}
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1400px);
		}	
	}
</style>


// WEBPACK FOOTER //
// Classify.vue?d49b10d4